if (!window.vibranetCardInfoBound) {
  window.vibranetCardInfoBound = true;

  document.addEventListener('click', (event) => {
    const openInfo = event.target.closest('[data-vb-info-open]');
    if (openInfo) {
      const siblingDialog = openInfo.nextElementSibling && openInfo.nextElementSibling.matches('dialog')
        ? openInfo.nextElementSibling
        : null;
      const dialog = siblingDialog || document.getElementById(openInfo.dataset.vbInfoOpen);
      if (!dialog) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (typeof dialog.showModal === 'function') {
        if (dialog.open) dialog.close();
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      return;
    }

    const closeInfo = event.target.closest('[data-vb-info-close]');
    if (closeInfo) {
      const dialog = closeInfo.closest('dialog');
      if (dialog) dialog.close();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('.vb-card-info-modal[open]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });
}
